import React from 'react';

import routes from 'sitewide-js/core_pre_webpack/routes';
import ExportFormatModal from 'js/export_format/ExportFormatModal';

interface Props {
  apiPath: string;
  recordCount: number;
}

const ProfileVisitorsExportModal: React.FC<Props> = ({
  apiPath,
  recordCount,
}) => (
  <ExportFormatModal
    apiPath={apiPath}
    exportType="profile_visitors"
    breadcrumbLabel="Profile Visitors"
    csvDescription="Open in Excel, Google Sheets, or Numbers. One row per visitor."
    recordCount={recordCount}
    recordNoun="visitor"
    calloutTitle="Premium turns anonymous traffic into named scholars."
    calloutDesc="Profile visitors helps you identify the researchers and institutions following your work."
    resolveDownloadHref={(id) =>
      routes.download_profile_visitors_export_url({
        profile_visitors_export_id: id,
      })
    }
  />
);

export default ProfileVisitorsExportModal;
